<div class="bg-white h-100 text-center">
  <div class="block-top-padding">
    <div class="lock-icon-style">
      <i class="fa fa-lock" aria-hidden="true"></i>
    </div>
    <h2>Access Denied!</h2>
    <p>You do not have access to this page.</p>
  </div>
</div>
